import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_LAYOUT_WIDGETS } from 'data-hooks/queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';

const useProductLayoutWidgets = (id, slug, queryOptions = {}) => {
  const { variables, skip } = usePDPApolloQueryVariables(id, slug);

  const { loading, error, data } = useSuspenseQuery(PRODUCT_LAYOUT_WIDGETS, {
    variables,
    skip,
    context: { noBatch: true },
    ssr: queryOptions?.ssr ?? true,
  });

  return {
    loading: loading || !data,
    error,
    data: data?.productLayoutWidgets,
  };
};

export default useProductLayoutWidgets;
